module.exports = __webpack_public_path__ + "img/paron.2d6c508e.png";